/**
 * Created by 唐亦慧 on 2018/2/6.
 * zhouyanping 2021年4月16日08:29:28 update
 * 1、隐藏价格，热销、新品排序信息。
 * 2、新增商品系列展示。
 */
import React from 'react';
import Reflux from 'reflux';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import {
  Layout,
  Badge,
  Menu,
  Input,Radio,
  Avatar,
  message,
  Pagination,
  Breadcrumb,
} from 'antd';
import '../mall-menus.css';
import '../mallApp.css';
import {
  getMallProductList,
  isShowInventory,
  menuTree,
} from '../../service/mall';
import { getShoppingCarList } from '../../service/shoppingCar';
import {
  productActions,
  productStore,
} from '../mallHome/store';
import { getProductCategory } from '../../service/product';
import {
  commodityModelSelectionList,
} from '../../service/merchandise';
import { sKeylist } from '../../service/dictionary/dataitem';
import { returnFloat, config } from 'Utils';
const { Header, Content } = Layout;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class SearchMall extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(productStore);
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
    this.state = {
      maxKey: [this.props.location.query.key] || [],
      mainMenu: [],
      minMenu: [],
      mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px',
      showFlag: false, //一级菜单是否显示
      secondFlag: false, //二级菜单是否显示
      cartCount: 0, //购物车
      keyword: this.store.state.searchMallData.name, //关键字
      dataSource: [],
      dataLength: 0,
      lables: ['', '新品', '推荐', '热销', '爆款'],//活动
      condition: {
        selectIndex: '0',
        data: [
          {
            'code': 'isHot',
            'sort': 0,
            'text': '热销',
          },
          {
            'code': 'isNew',
            'sort': 0,
            'text': '新品',
          },
          /*{
            'code': 'view_count',
            'sort': 0,
            'text': '综合',
          },
          {
            'code': 'sales_volume',
            'sort': 0,
            'text': '销量',
          },
          {
            'code': 'created_date',
            'sort': 0,
            'text': '新品',
          },
          {
            'code': 'show_price',
            'sort': 0,
            'text': '价格',
          },*/
        ],
      },
      isShow: true, //是否显示库存
      zeroAdd: true, //是否0库存下单
      seriesOptions: [],  // 商品系列
      seriesStyle:{background:'#ffffff',height:'auto'}, // 商品系列样式
    };
    this.mouseEnter = this.mouseEnter.bind(this);
    this.getMinKey = this.getMinKey.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.menuShow = this.menuShow.bind(this);
    this.goList = this.goList.bind(this);
    this.goView = this.goView.bind(this);
    this.resize = this.resize.bind(this);
    this.getMainMenu = this.getMainMenu.bind(this);
    this.getCartCount = this.getCartCount.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.goView = this.goView.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.getData = this.getData.bind(this);
    this.conditionChange = this.conditionChange.bind(this);
    this.isShowInventory = this.isShowInventory.bind(this);
  }

  componentDidMount() {
    window.onresize = this.resize;
    this.getMainMenu();
    this.getCartCount();
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    this.isShowInventory();
    this.getData();

    // 查询商品系列数据字典
    sKeylist({ sKey: 'commodity_series' }).then(res => {
      if (res.status) {
        let list =  (res.data || []).map(x => ({
          value: x.sKey,
          text: x.name,
          url: x.filePath ? `${config.server}/${x.filePath}` : '',
        }))

        this.setState({
          seriesOptions:list,
          // seriesStyle:{...this.state.seriesStyle, minWidth:(list.length * 179)+'px'}
        });
      }
    });
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if (path[1] === 'mallCommon' && path[2] === 'productDetail') { //当是详情页是整个保存
      var newSearch1 = {
        ...this.store.state.searchMallData,
      };
      productActions.searchChange(newSearch1);
    } else {
      var newSearch = {
        ...this.store.state.searchMallData,
        name: this.state.keyword,
        p: 1,
        s: 10,
        proBigType: '',
        proMiddleType: '',
        proDetailType: '',
        seriesCode: '',
        isHot: '1',
        isNew: '1',
      };
      productActions.searchChange(newSearch);
    }
  }

  isShowInventory() {
    isShowInventory().then((result) => {
      if (result && result.status) {//{show_inventory: "N", allow_reservation: "Y"}
        var isShowInventory = result.data;
        if (isShowInventory.show_inventory && isShowInventory.show_inventory == 'N') {
          this.setState({
            isShow: false,
          });
        } else {
          this.setState({
            isShow: true,
          });
        }
        if (isShowInventory.allow_reservation && isShowInventory.allow_reservation == 'N') {
          this.setState({
            zeroAdd: false,
          });
        } else {
          this.setState({
            zeroAdd: true,
          });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  //获取菜单
  getMainMenu() {
    getProductCategory().then((result) => {
      if (result.status) {
        const filterEmpty = (list, codePath) => list.map(x => {
          let key = x.code; // 实际使用的业务数据是 code；
          if (x.children && x.children.length) {
            return {
              ...x,
              key: key, // 使用实际业务数据重新给 key 赋值
              value: key, // 使用实际业务数据重新给 value 赋值
              isLeaf: false,
              disableCheckbox: !x.categoryId,
              codePath: [...codePath, x.code],
              children: filterEmpty(x.children, [...codePath, x.code]),
            };
          }
          return {
            ...x,
            key: key, // 使用实际业务数据重新给 key 赋值
            value: key, // 使用实际业务数据重新给 value 赋值
            isLeaf: true,
            disableCheckbox: !x.categoryId,
            codePath: [...codePath, x.code],
            children: undefined,
          };
        });
        const tree = filterEmpty(result.data || [], []);
        this.setState({
          mainMenu: tree,
        });
        if ((window.document.body.clientHeight - 64 - 128 - 132) > (result.data.length * 42)) {
          this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
        } else {
          this.setState({ mainHeight: result.data.length * 42 + (100 - 0) + 'px' });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  resize() {
    if (this.state.mainMenu.length > 0) {
      if ((window.document.body.clientHeight - 64 - 128 - 132) > (this.state.mainMenu.length * 42)) {
        this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
      } else {
        this.setState({ mainHeight: this.state.mainMenu.length * 42 + (100 - 0) + 'px' });
      }
    } else {
      this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
    }
  }

  //获取购物车商品数量
  getCartCount() {
    const params = {
      userId: this.userData.id,
      name: '',
      category: [],
      active: '',
      s: 10,
      p: 1,
      channelCode: this.channelData.split('|')[1] || '',
    };
    getShoppingCarList(params).then((result) => {
      if (result.status && result.data) {
        this.setState({
          cartCount: result.data.total || 0,
        });
      } else {
        if (!result.status) message.error(result.message);
      }
    });
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  goList({ item, key, keyPath }) {
    const [code, index] = key.split('_');
    const { mainMenu } = this.state;
    this.setState({
      secondFlag: false,
      showFlag: false,
      maxKey: [index],
    });
    productActions.changeValue('maxKeyValue', mainMenu[index].value);
    productActions.changeValue('minKeyValue', '');
    productActions.changeValue('selectIndex', '0');
    this.goView('/mallHome');
    var newSearchData = {
      ...this.store.state.searchMallData,
      keyword: '',
      proBigType: mainMenu[index].value,
      proMiddleType: '',
      proDetailType: '',
      isHot: '',
      isNew: '',
      p: 1,
    };
    productActions.searchChange(newSearchData);
  }
  // 查询分类信息
  onChangeSeries(event){
    console.log(event.target)
    productActions.searchChange({...this.state.searchMallData, ...{seriesCode:event.target.value}});
    // 查询商品
    this.getData();
  }
  getMinKey({ item, key, keyPath }) {
    const [code, index] = key.split('_');
    const { mainMenu, maxKey, minMenu } = this.state;
    this.setState({
      secondFlag: false,
      showFlag: false,
    });
    productActions.changeValue('maxKeyValue', mainMenu[maxKey[0]].value);
    productActions.changeValue('minKeyValue', minMenu[index].value);
    productActions.changeValue('selectIndex', '0');
    this.goView('/mallHome');
    var newSearchData2 = {
      ...this.store.state.searchMallData,
      proMiddleType: code,
      isHot: '',
      isNew: '',
    };
    productActions.searchChange(newSearchData2);
  }

  mouseEnter(e) {
    const [code, index] = e.key.split('_');
    const firstMenu = { children: [], key: '', label: '全部', leaf: true, type: null, value: '' };
    var minMenu = [...this.state.mainMenu[index].children];
    if (minMenu.length > 0) {
      minMenu.unshift(firstMenu);
    }
    this.setState({
      secondFlag: true,
      maxKey: [index],
      selectKeys: [index],
      maxKeyValue: code,
      minMenu,
    });
  }

  mouseLeave(e) {
    this.setState({
      secondFlag: false,
      showFlag: false,
    });
  }

  menuShow() {
    this.setState({
      showFlag: !this.state.showFlag,
      maxKey: [],
    });
  }

  toggleHome() {
    let url = window.location.href;
    if (/dms-pc/.test(url)) {
      window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
    } else {
      window.location.href = '/#/home';
    }
  }

  //关键字改变
  keywordChange(e) {
    this.setState({
      keyword: e.target.value,
    });
  }

  toGetMall() {
    if (this.state.keyword) {
      var newSearch = {
        ...this.store.state.searchMallData,
        name: this.state.keyword,
        p: 1,
        s: 10,
      };
      productActions.searchChange(newSearch);
      this.getData();
    } else {
      message.info('请输入商品名称');
    }
  }

  //获取数据
  getData() {
    if (!this.store.state.searchMallData.name) {
      return;
    }
    this.setState({ loading: true });
    commodityModelSelectionList(this.store.state.searchMallData).then((result) => {
      this.setState({ loading: false });
      if (result.status) {
        this.setState({
          dataSource: (result.data || []).map(x => ({
            ...x,
            picPreviewUrl: `${config.server}${x.picPreviewUrl}`
          })),
          dataLength: result.total || 0,
        });
      } else {
        message.error(result.message);
      }
    });
  }

  //顶部菜单改变
  conditionChange({ item, key, keyPath }) {
    const {condition} = this.state;
    if (key == condition.selectIndex) {
      condition.data[key].sort = condition.data[key].sort ? 0 : 1
    } else {
      condition.data = condition.data.map((x, index) => ({
        ...x,
        sort: index == key ? 1 : 0
      }))
    }
    let tmp = {};
    condition.data.forEach(x => {
      tmp[x.code] = x.sort;
    })
    this.setState({
      secondFlag: false,
      condition: {
        ...condition,
        selectIndex: key,
      },
    }, () => {
      let newSearch = {
        ...this.store.state.searchMallData,
        ...tmp,
        p: 1,
      };
      productActions.searchChange(newSearch);
      this.getData();
    });
  }

  pageChange(page, pageSize) {
    var newPage = {
      ...this.store.state.searchMallData,
      p: page,
    };
    productActions.searchChange(newPage);
    this.getData();
  }

  render() {
    const { zeroAdd, condition, cartCount, secondFlag, showFlag, maxKey, minMenu, mainMenu, 
      seriesOptions,seriesStyle, isShow, lables, dataLength, dataSource } = this.state;
    return <div>
      <Layout style={{ background: '#fff' }}>
        <Header className='home-header'>
          <div className="all-goods" style={{ cursor: 'pointer' }} onClick={this.menuShow}>
            <span>全部商品分类</span>
            {
              showFlag ?
                <i style={{ paddingLeft: '10px', fontSize: '16px' }} className="comIcon dmsArrowUp"></i>
                :
                <i style={{ paddingLeft: '10px', fontSize: '16px' }}
                   className="comIcon dmsArrowDown"> </i>
            }
          </div>
          {showFlag &&
          <div className='mall-menu' style={{ top: '128px' }} onMouseLeave={this.mouseLeave}>
            {
              secondFlag &&
              <div className="second-menu">
                <Menu mode="horizontal"
                      theme='second'
                      selectedKeys={[this.state.minKeyValue ? `${this.state.minKeyValue}` : '']}
                      onClick={this.getMinKey}>
                  {
                    minMenu.map((min, key) => {
                      return <Menu.Item key={`${min.code}_${key}`} className={key == 0 ? 'all' : ''}>
                        <span>{min.label}</span>
                      </Menu.Item>;
                    })
                  }
                </Menu>
              </div>
            }
            <Menu theme="mall"
                  mode="inline"
                  onClick={this.goList}>
              {
                mainMenu.map((main, key) => {
                  return <Menu.Item className={key == maxKey[0] && secondFlag ? 'menu-active' : ''}
                                    key={`${main.code}_${key}`} onMouseEnter={this.mouseEnter}>
                    <span>{main.label}</span>
                  </Menu.Item>;
                })
              }
            </Menu>
          </div>
          }
          {/*<div className="mall-logo">
           <a href="#" style={{cursor: 'default'}}>
           <h1>
           前海圆舟
           </h1>
           </a>
           </div>*/}
          <div className="mall-search">
						<Input placeholder='请输入商品名称' onChange={this.keywordChange.bind(this)} type="text"
                   onPressEnter={() => this.toGetMall()}
                   defaultValue={this.state.keyword} />
            <button onClick={this.toGetMall.bind(this)}>搜 索</button>
          </div>
          {/*<div className='mall-cart' onClick={this.goView.bind(this, '/mallCart')}>
            <Badge count={cartCount}>
              <i className='comIcon dmsCart'></i>
              <span className='cart-word'>我的购物车</span>
            </Badge>
          </div>*/}
          <div className='mall-cart' onClick={this.goView.bind(this, '/mallCart')}>
            <i className='comIcon dmsCart'></i>
            <span className='cart-word'>我的购物车</span>
            <Badge count={cartCount}>
              <span>&emsp;</span>
            </Badge>
          </div>
          {/*<div className="mall-go" onClick={this.toggleHome}>
           切换到卖家
           </div>*/}
        </Header>
      </Layout>
      <Content style={{ minHeight: this.state.mainHeight, background: '#fff', padding: '0 90px 50px 90px' }}>
        <div className='content-title'>
          <Breadcrumb separator=">">
            <Breadcrumb.Item style={{ cursor: 'pointer' }}
                             onClick={this.goView.bind(this, '/mallHome')}>首页</Breadcrumb.Item>
            <Breadcrumb.Item>{`搜索“${this.store.state.searchMallData.name}”`}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className='content-menu' style={{height:'auto'}}>
          {/* <Menu mode="horizontal"
                theme='filter'
                onClick={this.conditionChange}
                selectedKeys={[condition.selectIndex]}>
            {
              condition.data.map((x, index) => {
                return <Menu.Item key={`${index}`}>
                  <span>{x.text}</span>
                  &emsp;
                  {index == condition.selectIndex && <i className={`comIcon${x.sort == 0 ? ' arrowDown' : ' arrowUp'}`}></i>}
                </Menu.Item>;
              })
            }
          </Menu> */}
          <div className="dms-radio-img-box">
            <RadioGroup onChange={this.onChangeSeries.bind(this)} style={seriesStyle}>
              {
                seriesOptions.map(x => (
                  <RadioButton key={x.value} className="dms-radio-img" value={x.value}>
                    <Avatar className="ant-avatar-max" src={x.url} />
                    <p>{x.text}</p>
                  </RadioButton>
                ))
              }
            </RadioGroup>
          </div>
        </div>
        {
          dataSource.length > 0 &&
          <div className='goods-list clear'>
            {
              dataSource.map((product, key) => {
                return <dl key={key}>
                  <dt onClick={this.goView.bind(this, `/mallCommon/productDetail/${product.id}/${product.productId}/select`)}>
                    <img src={product.picPreviewUrl ? product.picPreviewUrl : require('../../assets/images/product-default.png')}
                         alt="图片加载失败" />
                    {
                      product.minPrice > product.minPromotionPrice && product.promotionCount > 0 &&
                      <div></div>
                    }
                    {
                      product.minPrice > product.minPromotionPrice && product.promotionCount > 0 &&
                      <p>促销</p>
                    }
                    {
                      product.inventory == 0 && !zeroAdd &&
                      <i className="dmsIcon dmsSoldOut"></i>
                    }
                  </dt>
                  <dd>
                    <div
                      onClick={this.goView.bind(this, `/mallCommon/productDetail/${product.id}`)}>
                      {
                        lables[product.labeling || 0] &&
                        <span style={{
                          display: 'inline-block',
                          fontSize: '12px',
                          height: '17px',
                          lineHeight: '14px',
                          padding: '0 3px',
                          border: '1px solid #d61518',
                          color: '#d61518',
                          borderRadius: '3px',
                          marginRight: '5px',
                        }}>{lables[product.labeling]}</span>
                      }
                      {product.name}
                    </div>
                    <p>
                      <span>{returnFloat(product.showPrice)}</span>
                      {/* {
                       product.minPrice > product.minPromotionPrice && product.promotionCount > 0 &&
                       <span style={{
                       fontSize: '12px',
                       color: '#777',
                       textDecoration: 'line-through',
                       paddingLeft: '10px',
                       float: 'left'
                       }}>￥{returnFloat(product.minPrice)}</span>
                       } */}
                      {
                        isShow &&
                        <span style={{
                          float: 'right',
                          fontSize: '12px',
                        }}>库存{product.inventory}</span>
                      }
                      {
                        (!isShow && !zeroAdd) && product.inventory > 0 &&
                        <span style={{ float: 'right', fontSize: '12px' }}>有货</span>
                      }
                      {
                        (!isShow && !zeroAdd) && !(product.inventory > 0) &&
                        <span style={{ float: 'right', fontSize: '12px' }}>缺货</span>
                      }
                    </p>
                  </dd>
                </dl>;
              })
            }
          </div>
        }
        {
          dataSource.length > 0 &&
          <div className="mall-page">
            <Pagination
              showQuickJumper
              showTotal={total => `共 ${total} 条`}
              defaultCurrent={1}
              current={this.store.state.searchMallData.p}
              total={dataLength}
              onChange={this.pageChange}
              defaultPageSize={this.store.state.searchMallData.s}
            />
          </div>
        }
        {
          dataSource.length == 0 &&
          <div style={{
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            height: '500px',
          }}>
            <img style={{
              width: '200px',
              height: '200px',
              position: 'absolute',
              top: '28px',
              left: '50%',
              marginLeft: '-100px',
            }} src={require('../../assets/images/null.png')} alt="" />
            <p style={{
              width: '100%',
              height: '274px',
              paddingTop: '250px',
              textAlign: 'center',
              lineHeight: '24px',
              fontSize: '18px',
              color: '#999',
            }}>暂无商品</p>
          </div>
        }
      </Content>
    </div>;
  }
}
;
export default withRouter(SearchMall);



// WEBPACK FOOTER //
// ./src/mall/mallDetail/searchMall.js